import { SET_MESSAGE_CONFIRM_ACTION_TYPE } from './actions';

const defaultState = {
  message: null,
  maxWidth: 'xs',
};

const AlertReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MESSAGE_CONFIRM_ACTION_TYPE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default AlertReducer;
